import { render, staticRenderFns } from "./AddBatch.vue?vue&type=template&id=2f96afaa"
import script from "./AddBatch.vue?vue&type=script&lang=js"
export * from "./AddBatch.vue?vue&type=script&lang=js"
import style0 from "./AddBatch.vue?vue&type=style&index=0&id=2f96afaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports